export default __webpack_public_path__ + "static/media/warning--turn-left-or-right--g1.386986eb.png";